import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router';
import Select from 'react-select';
import { useGetSearchBarCountriesQuery, useGetAllSubjectsQuery } from 'services/exploreApi';
import { CommonHash, LandingComponent } from 'app/types';
import Text from 'common/components/Text/Text';
import { useMediaQuery } from 'react-responsive';
import styles from '../LandingForm.module.scss';
import { setFilters } from 'features/session/sessionSlice';
import { useAppDispatch } from 'app/hooks';
import { Button } from 'react-bootstrap';
import { navigateTop } from 'common/utils';

interface PreviewComponentProps {
  landing_cmp: LandingComponent;
}

const SearchBarPreview = ({ landing_cmp }: PreviewComponentProps): React.ReactElement => {
  const isMobile = useMediaQuery({ maxWidth: 768 });
  const [subjectsFilter, setsubjectsFilter] = useState<CommonHash[]>([]);
  const [degreeType, setDegreeType] = useState('');
  const [locationsFilter, setlocationsFilter] = useState<CommonHash[]>([]);
  const [tuitionFilter, setTuitionFilter] = useState<CommonHash | undefined>({});
  const [tuitionMin, setTuitionMin] = useState<number>(-1);
  const [tuitionMax, setTuitionMax] = useState<number>(-1);

  const tuitionFilterOptions = [
    { label: 'Any', value: 'none-none' },
    { label: '<5K', value: '0-5' },
    { label: '5-10K', value: '5-10' },
    { label: '10-20K', value: '10-20' },
    { label: '20-30K', value: '20-30' },
    { label: '30-50K', value: '30-50' },
    { label: '50K+', value: '50' },
  ];

  const degreeTypeOptions = [
    { label: 'Bachelors', value: 'bachelors' },
    { label: 'Masters', value: 'masters' },
    // { label: 'Integrated', value: 2 },
    // { label: 'Diploma', value: 3 },
  ];

  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const { data: subjects, isLoading: subjectsLoading } = useGetAllSubjectsQuery();
  const { data: countries, isLoading: countriesLoading } = useGetSearchBarCountriesQuery();

  useEffect(() => {
    if (tuitionFilter && tuitionFilter.value) {
      if (tuitionFilter.value.split('-')[0] !== 'none') {
        setTuitionMin(parseInt(tuitionFilter.value.split('-')[0]));
      }
      if (tuitionFilter.value.split('-')[1] !== 'none') {
        setTuitionMax(parseInt(tuitionFilter.value.split('-')[1]));
      }
    }
  }, [tuitionFilter]);

  const handleApplyFilters = () => {
    const filtersToApply: CommonHash = {};
    if (locationsFilter.length > 0) {
      filtersToApply['country_id'] = locationsFilter.map((l) => l.value);
    }
    if (tuitionMin >= 0) {
      filtersToApply['tuition_min'] = tuitionMin;
    }
    if (tuitionMax >= 0) {
      filtersToApply['tuition_max'] = tuitionMax;
    }
    dispatch(setFilters(filtersToApply));
    navigate(`/explore/${degreeType || 'masters'}`);
    navigateTop();
  };

  return (
    <div
      id={landing_cmp.html_id}
      key={landing_cmp.id}
      className={landing_cmp.class_name}
      style={{
        width: landing_cmp.size !== 'sm' && landing_cmp.size !== 'md' ? landing_cmp.size : 'auto',
        padding: landing_cmp.size === 'sm' ? '60px 12rem' : '60px 4vw',
        margin: landing_cmp.gap,
        background: !(landing_cmp.background instanceof File) ? landing_cmp.background : 'auto',
        backgroundSize: landing_cmp.background_size,
        backgroundImage: `url(${landing_cmp.background_image})`,
        display: 'flex',
        justifyContent: 'center',
      }}
    >
      <div className={styles.barContainer}>
        <div
          className={styles.searchBarSection}
          style={!isMobile ? { paddingLeft: '20px' } : { borderBottom: '1px solid #E8F3FE' }}
        >
          <Text
            size={16}
            weight={500}
            inlineStyle={
              !isMobile
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                    paddingLeft: '10px',
                    paddingTop: '5px',
                  }
                : {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                  }
            }
          >
            <i className="bi bi-geo-alt"></i>&nbsp; Location
          </Text>
          <Select
            isClearable
            isSearchable
            isMulti
            classNamePrefix="react-select"
            placeholder="Select the location"
            options={countries?.data.map((c) => ({ label: c.name, value: c.id })) || []}
            onChange={(selectedOption: any) => setlocationsFilter(selectedOption)}
            isLoading={countriesLoading}
            value={locationsFilter}
          />
        </div>
        {!isMobile && (
          <div
            className="vl"
            style={{
              borderLeft: '1px solid #E3EAFB',
              width: '1px',
              height: '31px',
              paddingRight: '24px',
            }}
          ></div>
        )}
        <div
          className={styles.searchBarSection}
          style={isMobile ? { borderBottom: '1px solid #E8F3FE' } : {}}
        >
          <Text
            size={16}
            weight={500}
            inlineStyle={
              !isMobile
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                    paddingLeft: '10px',
                    paddingTop: '5px',
                  }
                : {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                  }
            }
          >
            <i className="bi bi-journal-text"></i>
            &nbsp; Degree type
          </Text>
          <Select
            classNamePrefix="react-select"
            placeholder="Select degree type"
            options={degreeTypeOptions}
            onChange={(o) => setDegreeType(o?.value || 'masters')}
            value={degreeTypeOptions?.filter(({ value }: { value: string }) => value == degreeType)}
          />
        </div>
        {!isMobile && (
          <div
            className="vl"
            style={{
              borderLeft: '1px solid #E3EAFB',
              width: '1px',
              height: '31px',
              paddingRight: '24px',
            }}
          ></div>
        )}
        <div className={styles.searchBarSection}>
          <Text
            size={16}
            weight={500}
            inlineStyle={
              !isMobile
                ? {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                    paddingLeft: '10px',
                    paddingTop: '5px',
                  }
                : {
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    color: '#193676',
                  }
            }
          >
            <i className="bi bi-cash-coin"></i>
            &nbsp; Budget
          </Text>
          <Select
            isClearable
            isSearchable
            classNamePrefix="react-select"
            options={tuitionFilterOptions}
            onChange={(selectedOption: any) => setTuitionFilter(selectedOption)}
            placeholder="Select budget range"
            value={tuitionFilter?.value ? tuitionFilter : null}
            // defaultInputValue={''}
          />
        </div>
        {isMobile ? (
          <Button
            onClick={handleApplyFilters}
            style={{
              fontSize: '16px',
              fontWeight: '600',
              display: 'flex',
              justifyContent: 'center',
              gap: '20px',
            }}
          >
            Search <i className="bi bi-search"></i>
          </Button>
        ) : (
          <div className={styles.searchButtonContainer} onClick={handleApplyFilters}>
            <i className="bi bi-search"></i>
          </div>
        )}
      </div>
    </div>
  );
};

export default SearchBarPreview;
